import type { ReportAnalytics, ReportKind } from "../../types";
import { sonMatni } from "../detail/KpiRow";

/** Son matni — yagona manba `detail/KpiRow` (hub komponentlari shu yerdan oladi). */
export { sonMatni };

/** `totals` kalitiga mos matn — foiz kalitida `%` qo'shiladi. */
export function totalMatni(key: string, value: number): string {
	return key === "rate" ? `${sonMatni(value)}%` : sonMatni(value);
}

/**
 * Kartaning pastki satrida ko'rsatiladigan `totals` kaliti.
 *
 * ⚠️ Kalit spec §2.4 jadvalidan; ro'yxatda yo'q (yangi) kind uchun
 * `totals[0]` ishlatiladi. Yorliq `analytics.totals.<kalit>` dan —
 * yangi i18n kaliti yaratilmaydi.
 */
export const CARD_STAT_KEY: Record<ReportKind, string> = {
	// biome-ignore lint/style/useNamingConvention: hisobot kaliti snake_case (kontrakt §3.1)
	attendance_daily: "present",
	// biome-ignore lint/style/useNamingConvention: hisobot kaliti snake_case (kontrakt §3.1)
	attendance_monthly: "rate",
	lateness: "lateCount",
	// biome-ignore lint/style/useNamingConvention: hisobot kaliti snake_case (kontrakt §3.1)
	work_time: "workedMin",
	// biome-ignore lint/style/useNamingConvention: hisobot kaliti snake_case (kontrakt §3.1)
	zone_exits: "unpermitted",
	// biome-ignore lint/style/useNamingConvention: hisobot kaliti snake_case (kontrakt §3.1)
	fake_location: "high",
	violations: "events",
	tasks: "active",
	leads: "leads",
};

export function cardStat(
	kind: string,
	totals: ReportAnalytics["totals"]
): ReportAnalytics["totals"][number] | undefined {
	const kalit = CARD_STAT_KEY[kind as ReportKind];

	return totals.find((total) => total.key === kalit) ?? totals[0];
}

/**
 * Ruxsatli/ruxsatsiz ustunining och qismi — asosiy rangning suyultirilgani.
 * ⚠️ Hex emas: `color-mix` CSS o'zgaruvchisi orqali dark rejimda ham ishlaydi.
 */
export const OCH_QIZIL = "color-mix(in srgb, var(--chart-kelmagan) 40%, var(--chart-surface))";

/** Ikonka foni: rangning 12% i sirt ustida. */
export function ikonkaFoni(rang: string): string {
	return `color-mix(in srgb, ${rang} 12%, var(--chart-surface))`;
}
